import { merge } from 'shared/utils'
import { AUTHENTICATION_QUERY } from './queries'

const __typename = 'AuthenticationInformation'

export const defaults = {
  authentication: {
    __typename,
    email: '',
    adminEmail: null,
    isAuthenticated: false,
    isLegacyAuthenticated: false,
    isAuthenticating: false,
    isAdmin: false,
    isReturningCustomer: false,
    isCoreCustomer: false,
    error: null,
    boCode: null,
    retailBoCode: null,
    loanProCustomerId: null,
    qFundCustomerId: null,
    currentAppLoanNumber: '',
    transient: null,
    firstName: null,
    lastName: null,
    isEnrollment: false,
    customBrand: null,
    hasOnlinePendingOrigination: false,
    hasPendingApplication: false,
    pendingApplicationBrand: null,
    customerType: null,
    stateCode: null,
    zipCode: null,
    channel: null,
  },
}

export default {
  Mutation: {
    updateAuthentication: (
      _,
      {
        email,
        adminEmail,
        isAuthenticated,
        isLegacyAuthenticated,
        isAuthenticating,
        isAdmin,
        isReturningCustomer,
        isCoreCustomer,
        error,
        boCode,
        retailBoCode,
        loanProCustomerId,
        qFundCustomerId,
        currentAppLoanNumber,
        transient,
        firstName,
        lastName,
        isEnrollment,
        customBrand,
        hasOnlinePendingOrigination,
        hasPendingApplication,
        pendingApplicationBrand,
        customerType,
        stateCode,
        zipCode,
        channel,
      },
      { cache }
    ) => {
      const { authentication: oldAuthentication } = cache.readQuery({
        query: AUTHENTICATION_QUERY,
      })

      const newAuthentication = {
        __typename,
        email,
        adminEmail,
        isAuthenticated,
        isLegacyAuthenticated,
        isAuthenticating,
        isAdmin,
        isReturningCustomer,
        isCoreCustomer,
        error,
        boCode,
        retailBoCode,
        loanProCustomerId,
        qFundCustomerId,
        currentAppLoanNumber,
        transient,
        firstName,
        lastName,
        isEnrollment,
        customBrand,
        hasOnlinePendingOrigination,
        hasPendingApplication,
        pendingApplicationBrand,
        customerType,
        stateCode,
        zipCode,
        channel,
      }
      return merge(oldAuthentication, newAuthentication)
    },
  },
}
